import { connect } from 'react-redux'
import { closeSnackbar } from '../actions'
import MySnackbar from '../components/MySnackbar'


const mapStateToProps = (state) => {
	return {
		snackbarOpen: state.snackbar.snackbarOpen, 
		snackbarMessage: state.snackbar.snackbarMessage
	};
}

const SnackbarContainer = connect(
	mapStateToProps
)(MySnackbar)

export default SnackbarContainer


// WEBPACK FOOTER //
// ./src/containers/SnackbarContainer.js